module.exports = __webpack_public_path__ + "img/162.726f56d6.jpg";